import React from 'react';
import Cookies from 'js-cookie';


const UsuarioDisplay = ({ items, cargarUsuario }) => {

  if (items != null) {
    return (
      <>
        {/* <AlphabetList /> */}
        {items.map((item, index) => {
  return (
    <table> <thead>

    </thead>
    <tbody>
    <tr key={item.id} >
      <td >
        <button
          type="button"
        
          onClick={() => {
            cargarUsuario(item);
          }}
        >
          {item.id}-{item.email}
        </button>
      </td>
    </tr>
    </tbody>
    </table>
  );
})}
      </>
    );
  }
}

export default UsuarioDisplay; 
